export default __webpack_public_path__ + "static/media/image.ceylon-sky.26e9fff8.png";